module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items.length) ? _c('Info', {
    attrs: {
      "items": _vm.filteredData
    }
  }) : _c('Warning', {
    attrs: {
      "isHeader": false
    }
  }, [_c('p', [_vm._v("В этом месяце заданий нет.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee062f6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/list/ListBlock.vue
// module id = 2bf7e18194e0d6b7b39d
// module chunks = 7